import React, { useState } from 'react';
import { Accordion } from './Accordion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(-1);
  const faqs = [{
    q: '¿Sirve si no sé nada de LSA?',
    a: 'Sí. El sistema empieza desde cero absoluto. El Tomo 1 asume que nunca viste una seña en tu vida.'
  }, {
    q: '¿Está adaptado al LSA argentino?',
    a: '100%. Todo basado en el LSA actualizado a 2026, con variaciones regionales. No es material genérico ni en inglés.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Acceso inmediato después del pago. Digital — celular, tablet o computadora. También podés imprimirlo.'
  }, {
    q: '¿Qué diferencia hay entre los dos planes?',
    a: 'El Plan Base tiene los 7 tomos y 6 bonos — ideal para aprender LSA desde cero. El Plan Profesional agrega 4 módulos de vocabulario técnico especializado para usar en tu trabajo.'
  }, {
    q: '¿Para qué profesiones sirve el Plan Profesional?',
    a: 'Médicos, enfermeros, psicólogos, docentes, traductores, intérpretes, abogados, bancarios y cualquier profesional que trabaje con personas sordas.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, sin preguntas. Te devolvemos el 100%. Menos del 1% pide devolución.'
  }];
  return <section className="bg-lsa-light text-lsa-dark py-16 px-5" data-id="element-65">
      <div className="max-w-xl mx-auto" data-id="element-66">
        <h2 className="text-[28px] font-bold text-center mb-10 leading-tight" data-id="element-67">
          Lo que más nos preguntan
        </h2>

        <div data-id="element-68">
          {faqs.map((faq, index) => <Accordion key={index} theme="light" isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? -1 : index)} title={faq.q} data-id="element-69">
              <div className="pt-1 pb-2" data-id="element-70">
                <p className="text-[15px] text-lsa-dark/80 leading-relaxed" data-id="element-71">
                  {faq.a}
                </p>
              </div>
            </Accordion>)}
        </div>
      </div>
    </section>;
}